export default __webpack_public_path__ + "static/Logo-Tether-369fc36b02eb3dbca50d98248cfaf4bf.png";